import React from "react";
import { Button, Icon, Modal, Ref } from "semantic-ui-react";
import { getAlertModalState } from "../data/selectors";
import { useDispatch, useSelector } from "react-redux";
import { setAlertModalState } from "../data/actions";
import { useRef } from "react";

/**
 * AlertModalCommon
 * 
 * A reusable alert modal component.
 * 
 * @returns A JSX element representing the alert modal.
 */
const AlertModalCommon = () => {
  const buttonRef = useRef();
  const dispatch = useDispatch();
  const alertModalState = useSelector((state) => getAlertModalState(state));
  
  return (
    <Modal
      onClose={() => {
        dispatch(setAlertModalState({ ...alertModalState, isOpen: false }));
      }}
      onMount={() => buttonRef?.current?.focus()}
      open={alertModalState?.isOpen}
      size={alertModalState?.size}
      closeOnEscape={true}
      dimmer={"blurring"}
    >
      <Modal.Header className="alertHeader">
        {alertModalState?.type === "error" ? (
          <Icon name="warning circle" className="alertIcon" />
        ) : alertModalState?.type === "success" ||
          alertModalState?.type === "confirmation" ? (
          <Icon name="check circle" className="alertSuccessIcon" />
        ) : null}
        {alertModalState?.title}
      </Modal.Header>
      <Modal.Content className="alertContent">
        <p className="alertMsg">{alertModalState?.msg}</p>
      </Modal.Content>
      <Modal.Actions className="alertAction">
        <Ref innerRef={buttonRef}>
          <Button
            className={
              alertModalState?.type === "error"
                ? "alertActionButton"
                : "alertSuccessButton"
            }
            onClick={() => {
              dispatch(
                setAlertModalState({ ...alertModalState, isOpen: false })
              );
              if (
                alertModalState &&
                typeof alertModalState.callBack === "function"
              ) {
                alertModalState.callBack();
              }
            }}
          >
            {alertModalState?.okButton || "OK"}
          </Button>
        </Ref>
        {alertModalState?.type === "confirmation" && (
          <Button
            className={
              alertModalState?.type === "error"
                ? "alertActionButton"
                : "alertSuccessButton"
            }
            onClick={() => {
              dispatch(
                setAlertModalState({ ...alertModalState, isOpen: false })
              );
            }}
          >
            {alertModalState?.cancelButton || "Cancel"}
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  );
};

export default AlertModalCommon;
